import { Star } from "lucide-react";
import { SectionHead, Reveal } from "./Reveal";
import { useContent } from "@/context/ContentContext";

export default function Reviews() {
  const c = useContent();
  const items = [...(c.reviews || [])].sort((a, b) => (a.order ?? 99) - (b.order ?? 99)).filter((r) => r.visible !== false);
  if (!items.length) return null;

  return (
    <section id="bewertungen" data-testid="reviews-section" className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHead
          eyebrow={c.texts.reviews_eyebrow}
          title={c.texts.reviews_title}
          sub={c.texts.reviews_sub}
        />

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((r, i) => (
            <Reveal key={r.id} delay={(i % 3) * 0.08} className="h-full">
              <blockquote
                data-testid="review-card"
                className="flex h-full flex-col justify-between rounded-2xl border border-[#27272A] bg-[#121215] p-7 transition-colors hover:border-blue-500/40"
              >
                <div>
                  <div className="flex gap-1" aria-label={`Bewertung: ${r.rating} von 5 Sternen`}>
                    {[1, 2, 3, 4, 5].map((n) => (
                      <Star
                        key={n}
                        className={`h-4 w-4 ${n <= r.rating ? "fill-blue-400 text-blue-400" : "text-zinc-700"}`}
                      />
                    ))}
                  </div>
                  <p className="mt-4 text-sm text-zinc-200 leading-relaxed">„{r.text}“</p>
                </div>
                <footer className="mt-6 flex items-center justify-between gap-3">
                  <span className="font-semibold text-zinc-100 text-sm">{r.author}</span>
                  <span className="font-mono text-[10px] uppercase tracking-wider text-zinc-400 text-right">
                    {r.date ? `${r.date}` : null}
                    {r.source ? `${r.date ? " · " : ""}${r.source}` : ""}
                  </span>
                </footer>
              </blockquote>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
